module.exports = __webpack_public_path__ + "img/trade-in-stock-img.14a33c41.jpeg";